"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionType = void 0;
var zod_1 = require("zod");
var CollectionType;
(function (CollectionType) {
    CollectionType.Schema = zod_1.z.enum(["images", "documents"]);
})(CollectionType || (CollectionType = {}));
exports.CollectionType = CollectionType;
